export default __webpack_public_path__ + "static/media/HyperComplexSem_template.f38a6978.pdf";